import { render, staticRenderFns } from "./ProgressoInteligente.vue?vue&type=template&id=66685f28&scoped=true&"
import script from "./ProgressoInteligente.vue?vue&type=script&lang=js&"
export * from "./ProgressoInteligente.vue?vue&type=script&lang=js&"
import style0 from "./ProgressoInteligente.vue?vue&type=style&index=0&id=66685f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66685f28",
  null
  
)

export default component.exports